module.exports = __webpack_public_path__ + "static/media/easter-top-banner.582b417c.png";